import React, { useState, useEffect, useRef } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import EmojiPicker from 'emoji-picker-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClose } from '@fortawesome/free-solid-svg-icons'

const RichTextEditor = ({ value, onSave, onCancel, quillRef }) => {
  const [editorValue, setEditorValue] = useState(value)
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)

  useEffect(() => {
    setEditorValue(value) // Sync with prop value
  }, [value])

  useEffect(() => {
    if (quillRef?.current) {
      const editor = quillRef.current.getEditor()
      if (editor) {
        setTimeout(() => {
          const endPosition = editor.getLength()
          editor.focus()
          editor.setSelection(endPosition, endPosition)
        }, 100)
      }
    }
  }, [])

  const handleEditorChange = content => {
    setEditorValue(content) // Ensure editorValue is updated
  }

  const handleEmojiClick = emojiObject => {
    const editor = quillRef.current?.getEditor()
    if (!editor) return

    editor.focus()
    let range = editor.getSelection()
    let cursorPosition = range ? range.index : editor.getLength()

    editor.insertText(cursorPosition, emojiObject.emoji)
    editor.setSelection(cursorPosition + emojiObject.emoji.length)

    setEditorValue(editor.root.innerHTML) // Update local state
  }

  const modules = {
    toolbar: { container: '#toolbar' }
  }

  return (
    <div className='relative'>
      {showEmojiPicker && (
        <div className='fixed right-[20%] top-[18%] z-50 bg-white shadow-xl ring-4 ring-gray-300 w-auto max-w-[380px] max-h-[350px] overflow-y-auto rounded-lg'>
          <div className='sticky top-0 bg-white w-full p-2 flex justify-end'>
            <button
              className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] text-[14px] sm:text-[18px] cursor-pointer'
              onClick={() => setShowEmojiPicker(false)}
            >
              ✖
            </button>
          </div>
          <EmojiPicker onEmojiClick={handleEmojiClick} />
        </div>
      )}

      <div id='toolbar' className='flex gap-2'>
        <button className='ql-bold' />
        <button className='ql-italic' />
        <button className='ql-underline' />
        {/* <button className='ql-link' /> */}
        <button className='emoji-btn' onClick={() => setShowEmojiPicker(true)}>😀</button>
      </div>

      <div className='flex gap-1 items-center justify-start'>
        <ReactQuill
          ref={quillRef}
          theme='snow'
          value={editorValue}
          placeholder='Enter Text'
          modules={modules}
          onChange={handleEditorChange}
          className='w-[250px] border-none py-2 px-1 rounded-lg text-sm placeholder:text-gray-400'
        />

        <div className='flex gap-2 items-center justify-center'>
          <button
            onClick={() => onSave(editorValue)}
            className='bg-blue-600 hover:bg-blue-700 flex justify-center items-center text-white text-[10px] font-medium px-4 py-2 h-[30px] rounded-md shadow-md'
          >
            <FontAwesomeIcon icon={faCheckCircle} className='text-sm' />
          </button>
          <button
            onClick={onCancel}
            className='bg-transparent hover:bg-gray-200 border flex justify-center items-center border-black border-opacity-10 text-black px-4 py-2 h-[30px] rounded-md'
          >
            <FontAwesomeIcon icon={faClose} className='text-sm' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default RichTextEditor
